import { useEffect, useRef } from "react";
import { Modal, ModalContent, ModalHeader } from "@chakra-ui/react";
import { useRouter } from "next/router";
import {
  useCurrentBrandData,
  useCurrentBrandId,
  useCurrentUserData,
  useFetchCurrentUser,
} from "lib/auth/currentUserHooks";
import ModalBlurOverlay from "components/UI/Modals/ModalBlurOverlay";
import NoAccountModalBody from "components/Layout/BrandSettings/NoAccountModal/Body";
import { AppMode, useAppMode } from "lib/routing/appMode";
import { SIGNUP } from "lib/routing/links";
import { asyncVoid } from "lib/errors/asyncVoidHandler";
import RedirectingOverlay from "components/Core/Auth/RedirectingOverlay";

export default function NoAccountModal() {
  const router = useRouter();
  const appMode = useAppMode();
  const currentBrandId = useCurrentBrandId();
  const currentUser = useCurrentUserData();
  const currentBrand = useCurrentBrandData();
  const { data: currentUserData } = useFetchCurrentUser();

  const initialFocusRef = useRef(null);

  const isSignupRedirectNeeded =
    appMode === AppMode.BRAND &&
    router.pathname !== SIGNUP &&
    !!currentUser &&
    !currentUser.isStaff &&
    !currentUser.isSuperuser &&
    currentUserData?.me?.brands.totalCount === 0 &&
    currentUserData?.me?.brokersList.length === 0;

  useEffect(() => {
    if (isSignupRedirectNeeded) asyncVoid(router.replace(SIGNUP));
  }, [isSignupRedirectNeeded, router]);

  if (appMode !== AppMode.BRAND) return null;
  if (router.pathname === SIGNUP) return null;

  if (isSignupRedirectNeeded) {
    return (
      <RedirectingOverlay isOpen header="Redirecting to Sign Up">
        Finish setting up your account.
      </RedirectingOverlay>
    );
  }

  const isCurrentBrandInvalid =
    !!currentUser && (!currentBrandId || currentBrand === null);

  return (
    <Modal
      isOpen={isCurrentBrandInvalid}
      onClose={() => {}}
      initialFocusRef={initialFocusRef}
    >
      <ModalBlurOverlay />
      <ModalContent>
        <ModalHeader color="magenta.veryDark">Choose an Account</ModalHeader>
        <NoAccountModalBody initialFocusRef={initialFocusRef} />
      </ModalContent>
    </Modal>
  );
}
